// Core
import styled from 'styled-components';

// Libraries
import { Segmented as AntDSegmented } from 'antd';

export const Component = styled(AntDSegmented)`
  border-radius: 4px;

  &.ant-segmented .ant-segmented-item-label {
    font-family: ${({ theme }) => theme.font.medium};
    color: ${({ theme }) => theme.color.optionsSwitch.optionsSwitchText};
    transition: color 0.1s ease-in-out;
    user-select: none;

    :hover :not(.ant-segmented-item-selected) {
      background-color: ${({ theme }) => theme.color.optionsSwitch.optionsSwitchHoverBgColor};
      color: ${({ theme }) => theme.color.optionsSwitch.optionsSwitchHoverTextColor};
    };
  };

  .ant-segmented-item-selected .ant-segmented-item-label {
    color: ${({ theme }) => theme.color.optionsSwitch.optionsSwitchSelectedText};
  };
`;
